// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8e72b211","867":"39a50ee6"}[chunkId] + ".chunk.js";
};